export default __webpack_public_path__ + "static/media/CNo.92-2.95fd3c22.jpg";